function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21.8 14.1l2.52-6.7c.26-.66-.12-1.2-.84-1.2H8.8l-.32-1.6C8.35 4 7.82 3.57 7.2 3.57H4.9c-.73 0-1.3.57-1.3 1.3s.57 1.3 1.3 1.3h1.25l1.72 7.95-2.57 5.8c-.18.4-.14.86.1 1.23s.65.6 1.1.6h1c0 1.46 1.16 2.63 2.6 2.63 1.44 0 2.6-1.16 2.6-2.6l3.9-.03c0 1.47 1.17 2.64 2.6 2.64 1.44 0 2.6-1.18 2.6-2.6l.3-.05c.72 0 1.3-.58 1.3-1.3s-.58-1.3-1.3-1.3H8.5l1.7-3.87h9.82c.72 0 1.5-.56 1.76-1.2z",
  className: ""
});

var SvgBasket = function SvgBasket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBasket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/basket.a8a096a5.svg";
export { ForwardRef as ReactComponent };